import { render, staticRenderFns } from "./PosN_Header.vue?vue&type=template&id=2f40f9b7"
import script from "./PosN_Header.vue?vue&type=script&lang=js"
export * from "./PosN_Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports